import flatten from 'latest_modules/lodash/flatten';
import map from 'latest_modules/lodash/map';
import find from 'latest_modules/lodash/find';
import emojiData from '../data/emoji';
import { webp } from '../util/url';

const emojiList = flatten(map(emojiData, 'emojis'));

const EMOJI_IMAGE_SET = 'twitter';
const EMOJI_URI =
  (window.tom.conf.path && window.tom.conf.path.resize) ||
  'https://resize.cdn.otakumode.com/';

export default {
  emojiColon2img(str) {
    const rxColons = new RegExp(':[a-zA-Z0-9-_+]+:', 'g');
    return (str || '').replace(rxColons, function (m) {
      const idx = m.substr(1, m.length - 2).toLowerCase();
      const emoji = find(emojiList, { name: idx });

      if (!emoji) {
        return m;
      }

      const emojiPath = webp(
        `${EMOJI_URI}bypass/emoji/${EMOJI_IMAGE_SET}/${emoji.image}`
      );
      return `<img class="emoji" src="${emojiPath}" alt="${emoji.name}">`;
    });
  }
};
